import get from 'lodash/get';

export const getSbaUserIsAuthenticating = (state) => get(state, 'authentication.sbaUser.isAuthenticating', false);
export const getSbaUserIsAuthenticated = (state) => get(state, 'authentication.sbaUser.isAuthenticated', false);
export const getSbaUserToken = (state) => get(state, 'authentication.sbaUser.token', null);
export const getSbaUserError = (state) => get(state, 'authentication.sbaUser.error', null);
